
// components/RecoveryPhraseBackup.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function RecoveryPhraseBackup({ onConfirm, onSkip }) {
  const [phrase, setPhrase] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
const [later, setLater] = useState(false);

  const { t } = useTranslation();

  const handleSubmit = async () => {
    const cleanPhrase = phrase.trim();
    const cleanConfirmation = confirmation.trim();

    setError('');

    if (!cleanPhrase) {
      setError(t('recoverybackup.error1'));
      return;
    }

    if (cleanPhrase.length < 16) {
      setError(t('recoverybackup.error2'));
      return;
    }

    if (cleanPhrase !== cleanConfirmation) {
      setError(t('recoverybackup.error3'));
      return;
    }

    if (!confirmed) {
      setError(t('recoverybackup.error4'));
      return;
    }

    try {
      setSaving(true);

      // Le parent reçoit la phrase choisie par l'utilisateur
      await onConfirm(cleanPhrase);

    } catch (err) {
      console.error(
        '❌ Erreur sauvegarde phrase:',
        err
      );

      setError(
        err.response?.data?.error ||
        err.message ||
        t('recoverybackup.error5')
      );

      setSaving(false);
    }
  };

const canContinue =
  later ||
  (
    phrase.trim() &&
    phrase.trim().length >= 16 &&
    phrase.trim() === confirmation.trim() &&
    confirmed
  );

  return (
  <div
    style={{
      width: '100%',
      maxWidth: '600px',
      maxHeight: 'calc(100vh - 32px)',
      margin: '16px auto',
      boxSizing: 'border-box',

      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',

      display: 'flex',
      flexDirection: 'column',

      overflow: 'hidden'
    }}
  >
    {/* CONTENU SCROLLABLE */}
    <div
      style={{
        padding: '24px',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        boxSizing: 'border-box'
      }}
    >

      <h2
        style={{
          marginTop: 0,
          marginBottom: '16px',
          color: '#e74c3c',
          fontSize: '22px',
          lineHeight: 1.3
        }}
      >
        {t('recoverybackup.titre')}
      </h2>

      <p
        style={{
          marginTop: 0,
          marginBottom: '20px',
          color: '#666',
          lineHeight: 1.5
        }}
        dangerouslySetInnerHTML={{
          __html: t('recoverybackup.introduction')
        }}
      />

      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '8px',
          marginBottom: '16px',
          fontWeight: 'bold',
          cursor: 'pointer',
          lineHeight: 1.4
        }}
      >
        <input
          type="checkbox"
          checked={later}
          onChange={(e) => setLater(e.target.checked)}
          style={{
            flexShrink: 0,
            marginTop: '3px'
          }}
        />

        <span>
          {t('recoverybackup.preference')}
        </span>
      </label>

      {!later && (
        <>
          <div
            style={{
              background: '#fff3cd',
              padding: '14px',
              borderRadius: '8px',
              marginBottom: '18px',
              color: '#856404',
              lineHeight: 1.5,
              fontSize: '14px'
            }}
            dangerouslySetInnerHTML={{
              __html: t('recoverybackup.warning')
            }}
          />

          <label
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 'bold'
            }}
          >
            {t('recoverybackup.input1')}
          </label>

          <textarea
            value={phrase}
            onChange={(e) => setPhrase(e.target.value)}
            placeholder={t('recoverybackup.placeholder1')}
            rows={4}
            disabled={saving}
            style={{
              width: '100%',
              boxSizing: 'border-box',
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              resize: 'vertical',
              fontSize: '15px',
              marginBottom: '16px',
              minHeight: '100px',
              fontFamily: 'inherit'
            }}
          />

          <label
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 'bold'
            }}
          >
            {t('recoverybackup.input2')}
          </label>

          <textarea
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            placeholder={t('recoverybackup.placeholder2')}
            rows={4}
            disabled={saving}
            style={{
              width: '100%',
              boxSizing: 'border-box',
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              resize: 'vertical',
              fontSize: '15px',
              marginBottom: '18px',
              minHeight: '100px',
              fontFamily: 'inherit'
            }}
          />

          {error && (
            <div
              style={{
                background: '#f8d7da',
                color: '#721c24',
                padding: '12px',
                borderRadius: '6px',
                marginBottom: '18px',
                lineHeight: 1.4,
                fontSize: '14px'
              }}
            >
              ❌ {error}
            </div>
          )}

          <label
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '8px',
              marginBottom: '18px',
              cursor: saving ? 'default' : 'pointer',
              lineHeight: 1.4
            }}
          >
            <input
              type="checkbox"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              disabled={saving}
              style={{
                width: '18px',
                height: '18px',
                flexShrink: 0,
                marginTop: '2px'
              }}
            />

            <span>
              {t('recoverybackup.final')}
            </span>
          </label>
        </>
      )}

      <button
        type="button"
        onClick={later ? onSkip : handleSubmit}
        disabled={!canContinue || saving}
        style={{
          padding: '13px 20px',
          background:
            canContinue && !saving
              ? '#27ae60'
              : '#95a5a6',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor:
            canContinue && !saving
              ? 'pointer'
              : 'not-allowed',
          width: '100%',
          minHeight: '46px',
          fontSize: '15px',
          fontWeight: '600',
          transition: 'background 0.2s ease'
        }}
      >
        {later
          ? t('recoverybackup.continuer')
          : t('recoverybackup.save')}
      </button>

    </div>
  </div>
);
}
